import { render, staticRenderFns } from "./StandappPasscodeOtpComponent.vue?vue&type=template&id=174a73d6&scoped=true&"
import script from "./StandappPasscodeOtpComponent.vue?vue&type=script&lang=js&"
export * from "./StandappPasscodeOtpComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174a73d6",
  null
  
)

export default component.exports